import { useContext, useEffect, useState } from "react";
import AuthContext from "../../../../auth/AuthContext";
import DashboardService from "../../../../services/DashboardService";
import { Skeleton } from "primereact/skeleton";
import incidentImg from "../../../../assets/icons/TotalIncidentCountsIcon.svg";
import learnerImg from "../../../../assets/icons/TotalLearnersCountIcon.svg";
import DecommissionImg from "../../../../assets/icons/DocumentIcon.svg";
import labImg from "../../../../assets/icons/TotalLabHoursIcon.svg";
import { ThemeContext } from "../../../../theme/ThemeContext";

const TotalLabHoursCard = () => {
  const authContext = useContext(AuthContext);
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    totalIncidents: 0,
    totalLearners: 0,
    totalLabHours: 0,
    decommissioned: 0,
  });

useEffect(() => {
    const controller = new AbortController();
    const fetchHours = async () => {
      setLoading(true);
      try {
        const response = await DashboardService.GetLabHours(authContext, controller.signal);

        if (controller.signal.aborted) return;

        if (response?.isSuccess && response?.data) {
          let totalIncidents = response.data.filter(
            (f) => f.configType === "TotalIncidents"
          );
          let totalLearners = response.data.filter(
            (f) => f.configType === "TotalLearners"
          );
          let totalLabHours = response.data.filter(
            (f) => f.configType === "TotalLabHours"
          );
          let decommissioned = response.data.filter(
            (f) => f.configType === "DECOMMISSIONED"
          );

          setData({
            totalIncidents: totalIncidents[0]?.configValue ?? 0,
            totalLearners: totalLearners[0]?.configValue ?? 0,
            totalLabHours: totalLabHours[0]?.configValue ?? 0,
            decommissioned: decommissioned[0]?.configValue ?? 0,
          });
        }
      } catch (err) {
        if (err.name === "AbortError") return;
        console.error(err);
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchHours();
    return () => controller.abort();
  }, [authContext]);

  const containerStyle = {
    height: "357px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  };

  const rowStyle = {
    display: "flex",
    gap: "12px",
    flex: 1,
    minHeight: 0, 
  };

  const colStyle = {
    flex: 1,
    minWidth: 0, 
  };
  if (loading) {
    return (
      <div style={containerStyle}>
        <div style={rowStyle}>
          <div style={colStyle}>
            <Skeleton width="100%" height="100%" borderRadius="12px" />
          </div>
          <div style={colStyle}>
            <Skeleton width="100%" height="100%" borderRadius="12px" />
          </div>
        </div>
        <div style={rowStyle}>
          <div style={colStyle}>
            <Skeleton width="100%" height="100%" borderRadius="12px" />
          </div>
          <div style={colStyle}>
            <Skeleton width="100%" height="100%" borderRadius="12px" />
          </div>
        </div>
      </div>
    );
  }

  const CardItem = ({ icon, label, value }) => (
    <div
      className="rounded-3 d-flex flex-column justify-content-center align-items-center text-center p-3 dropdown"
      style={{
        height: "100%",
        border: isDark ? "none" : "1px solid #a5b4be",
      }}
    >
      <img src={icon} alt="icon" width="35" height="35" className="mb-2" />
      <span className="fw-medium" style={{ fontSize: "14px" }}>
        {label}
      </span>
      <h2
        className="mb-0 mt-1"
        style={{ fontSize: "26px", fontWeight: "600" }}
      >
        {(value ?? 0).toLocaleString()}
      </h2>
    </div>
  );

  return (
    <div style={containerStyle}>
      <div style={rowStyle}>
        <div style={colStyle}>
          <CardItem icon={incidentImg} label="Total Incidents" value={data.totalIncidents} />
        </div>
        <div style={colStyle}>
          <CardItem icon={learnerImg} label="Total Learners" value={data.totalLearners} />
        </div>
      </div>
      <div style={rowStyle}>
        <div style={colStyle}>
          <CardItem icon={labImg} label="Total Lab Hours" value={data.totalLabHours} />
        </div>
        <div style={colStyle}>
          <CardItem icon={DecommissionImg} label="Total Documents" value={data.decommissioned} />
        </div>
      </div>
    </div>
  );
};

export default TotalLabHoursCard;